import service from "@/utils/request";
// 补课列表
export interface getRepairListInter {
  page: number;
  page_size: number;
  student_id?: number;
  teacher_id?: number;
  course_id?: number;
  class_id?: number;
  student_status?: number;
  make_up_status?: number;
  sort_field?: string;
  sort_type?: string;
}
// 补课列表
export const getLessonRepairListApi = (data: getRepairListInter) => {
  return service({
    url: "/api/v1/class/lesson/repair/list",
    method: "post",
    data,
  });
};
// 补课列表-数据统计
export const lessonRepairListStatisticsApi = (data: getRepairListInter) => {
  return service({
    url: "/api/v1/class/lesson/repair/list_statistics",
    method: "post",
    data,
  });
};
// 取消补课
export interface repairCancelInter {
  roll_call_student_id: number;
}
export const lessonRepairCancelApi = (params: repairCancelInter) => {
  return service({
    url: "/api/v1/class/lesson/repair/cancel",
    method: "post",
    params,
  });
};
// 补课详情
export const lessonRepairDetailApi = (params: repairCancelInter) => {
  return service({
    url: "/api/v1/class/lesson/repair/detail",
    method: "get",
    params,
  });
};
// 新增补课课次
export interface lessonRepairAddInter {
  student_id: number;
  relation_lesson_id: number;
  teacher_ids: [];
  main_teacher_id?: number;
  lesson_type: number;
  start_time: string;
  end_time: string;
  date: string;
  classroom_id?: number;
}
export const lessonRepairAddApi = (data: lessonRepairAddInter) => {
  return service({
    url: "/api/v1/class/lesson/repair/add",
    method: "post",
    data,
  });
};
export const lessonValetAddApi = (data: any) => {
  return service({
    url: "/api/v1/class/lesson/valet/add",
    method: "post",
    data,
  });
};
// 查看员工是否具有api权限
export interface staffCheckInter {
  api_path: string[];
}
export const staffCheckApi = (data: staffCheckInter) => {
  return service({
    url: "/api/v1/staff/check_api",
    method: "post",
    data,
  });
};
